import { Order as CanadaOrderPb } from "@repo/protobuf/gen/kikoff_canada/protobuf/models/shopping/order_pb";
import Protobuf, { MessageFrom } from "@repo/protobuf/utils";

import Product from "./Product.js";

type Order = {
  orderId: Order.Id;
  purchasedAt: Date;
  product: Product;
  downloadUrl?: string;
};

namespace Order {
  export type Id = string & {};
}

export default Order;

export namespace OrderCanada {
  export const normalize = (proto: MessageFrom<CanadaOrderPb>): Order => ({
    ...proto,
    product: proto.product!,
    purchasedAt: Protobuf.Timestamp.toDate(proto.purchasedAt!),
  });
}
